export const TERM_RETRIEVE_REQUEST = 'TERM_RETRIEVE_REQUEST';
export const TERM_RETRIEVE_SUCCESS = 'TERM_RETRIEVE_SUCCESS';
export const TERM_RETRIEVE_FAILURE = 'TERM_RETRIEVE_FAILURE';

export const TERM_EDIT_REQUEST = 'TERM_EDIT_REQUEST';
export const TERM_EDIT_SUCCESS = 'TERM_EDIT_SUCCESS';
export const TERM_EDIT_FAILURE = 'TERM_EDIT_FAILURE';

export const TERM_CREATE_REQUEST = 'TERM_CREATE_REQUEST';
export const TERM_CREATE_SUCCESS = 'TERM_CREATE_SUCCESS';
export const TERM_CREATE_FAILURE = 'TERM_CREATE_FAILURE';

export const TERM_DELETE_REQUEST = 'TERM_DELETE_REQUEST';
export const TERM_DELETE_SUCCESS = 'TERM_DELETE_SUCCESS';
export const TERM_DELETE_FAILURE = 'TERM_DELETE_FAILURE';

export const THES_CANCEL_ALL_REQUESTS = 'THES_CANCEL_ALL_REQUESTS';
export const THES_CANCEL_CREATE_REQUEST = 'THES_CANCEL_CREATE_REQUEST';

export const THES_COLLAPSE = 'THES_COLLAPSE';
export const THES_LIST_CLEAR = 'THES_LIST_CLEAR';



// WEBPACK FOOTER //
// ./src/js/actions/thesaurusActionTypes.js